export enum ThirdPartyEnum
{
    MOLLIE = 1,
    RABOBANK = 2,
    STRIPE = 3,
    ADYEN = 4,
    ORACLE = 5,
    NCR = 6,
    ATO = 7,
}